module.exports = __webpack_public_path__ + "static/media/allproducts.ab406ff2.jpg";